import { Heading, Text, Stack } from '@chakra-ui/react';


export function InsightsPanelHeading({ children }) {
    return <Heading size="md">{children}</Heading>
}

export function InsightsPanelText({ children }) {
    return <Text  mb="1">{children}</Text>
}

export function InsightsPanelStack({ children }) {
    return <Stack spacing={1}>{children}</Stack>
}
